// An online war room (docs/ARCHITECTURE.md §15): a real WebSocket to the edge, whose URL carries this seat's claim.

import { BrowserSocket } from '../online/browser-socket'
import { connectOnlineRoom, type OnlineRoomConnection } from './room-connection'

/** Opens the room socket (join next). Each socket reports the room's close code, which decides whether to rejoin. */
export function openOnlineRoom(roomUrl: string): Promise<OnlineRoomConnection> {
  return connectOnlineRoom(roomUrl, (url, observer) => new BrowserSocket(url, observer))
}
